import { lazy } from "react";

const JoinFoundersClubLazy = lazy(() => import("../JoinFoundersClub"));

export default JoinFoundersClubLazy;